"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProjectFilter = void 0;
const enum_1 = require("../../utils/enum");
exports.EProjectFilter = (0, enum_1.strEnum)(["ONLINE", "DRAFT", "ARCHIVED"]);
